const invoiceEcommerce = {
  state: {
    invoiceEcommerce: [],
  },
  getters: {
    listInvoiceEcommerce(state) {
      return state.invoiceEcommerce;
    },
  },
  mutations: {
    UPDATE_LIST(state, payload) {
      state.invoiceEcommerce = payload;
    },
    CLEAR_LIST(state, payload) {
      state.invoiceEcommerce = payload;
    },
  },
};

export default invoiceEcommerce;
